/**
 * Format volume number to display format
 * @param {number} volume - Volume number
 * @returns {string} - Formatted volume display
 */
export const formatVolumeDisplay = (volume) => {
  if (!volume) return '-'
  if (volume >= 1000000) return `${(volume / 1000000).toFixed(1)}M+`
  if (volume >= 1000) return `${(volume / 1000).toFixed(1)}K+`
  if (volume >= 500) return `500+`
  return `${volume}+`
}
